<script lang="ts">
	import ScriptsG2 from 'src/components/DevicesSettings/Scripts/ScriptsG2.svelte';
	import ScriptsG2V2 from 'src/components/DevicesSettings/Scripts/ScriptsG2V2.svelte';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import type { Device } from 'src/types/Device.ts';

	export let device: Device;
</script>

{#if $showNewLayout}
	<ScriptsG2V2 {device} />
{:else}
	<ScriptsG2 {device} />
{/if}
